//deps
import React, { memo, useCallback, useState } from "react";

// constants
import { CHANGE, CHANGE_PAYMENT_CTA_ARIA_LABEL, CHANGE_PAYMENT_OPTION } from "@payment-ui/constants/TurboPayment";

// widgets
import Chevron from "./Chevron";

//styles
import { ChangeButtonWrapper, ChangePaymentCtaContainerV2, MainContainer } from "./styles/ChangePaymentCtaV2.style";

interface ChangePaymentCtaV2Props {
    dataTestId: string;
    className?: string;
    onClick?: VoidFunction;
}

function ChangePaymentCtaV2({ className, onClick, dataTestId }: ChangePaymentCtaV2Props) {
    const [text, changeText] = useState(CHANGE_PAYMENT_OPTION);

    const onAnimationEnd = useCallback(() => {
        changeText(CHANGE);
    }, []);

    return (
        <MainContainer>
            <ChangeButtonWrapper>
                <ChangePaymentCtaContainerV2
                    data-testid={dataTestId}
                    variant="V2.body2.neutral.bold"
                    color="primary"
                    onAnimationEnd={onAnimationEnd}
                    className={className}
                    onClick={onClick}
                    aria-label={CHANGE_PAYMENT_CTA_ARIA_LABEL}
                    isLongText={text === CHANGE_PAYMENT_OPTION}
                >
                    {text}
                </ChangePaymentCtaContainerV2>
            </ChangeButtonWrapper>
            <Chevron />
        </MainContainer>
    );
}

export default memo(ChangePaymentCtaV2);
